import script from "./collectTimeDropPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./collectTimeDropPopup.vue?vue&type=script&setup=true&lang=ts"

import "./collectTimeDropPopup.vue?vue&type=style&index=0&id=ed5bdd2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed5bdd2c"]])

export default __exports__